/* src/app/components/profile-deletion/profile-deletion.component.scss */
.delete-profile-container {
  max-height: 80vh;
  padding: 24px;
}
.checkbox-square {
  --size: 20px;
  margin-right: 10px;
  min-width: 20px;
  min-height: 20px;
}
ion-checkbox::part(container) {
  border-radius: 6px;
  border: 2px solid #92949c;
}
.delete-banner {
  background-color: rgb(255, 0, 0);
  border-radius: 1rem;
}
ion-card-content {
  color: white;
  text-align: center;
  font-weight: bold;
}
/*# sourceMappingURL=profile-deletion.component.css.map */
